import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PlanosCtaSection.css';

const PlanosCtaSection = () => {
  const { t } = useTranslation();

  return (
    <section className="planos-cta-section">
      <div className="container">
        <h2 className="section-title">{t('planosCta.title')}</h2>
        <p className="section-subtitle">{t('planosCta.subtitle')}</p>
        <Link to="/planos" className="planos-cta-button">
          {t('planosCta.button')}
        </Link>
      </div>
    </section>
  );
};

export default PlanosCtaSection;
